<template>
    <b-card no-body>
        <div>
            <b-card-header>
                <span>{{ formData.display_name }}</span>
                <!-- <a class="pull-right" v-if="canEditForms" href="">Edit form</a> -->
            </b-card-header>
            <b-card-body>
                <h1>{{ formData.display_name }}</h1>
                <p>{{ formData.description }}</p>
            </b-card-body>
            <b-card-body>
                <div v-if="!formData.is_published">
                    {{ $t('text.Form_notready') }}
                </div>

                <div v-if="formData.is_published">
                    <form ref="form" @submit="submitForm">
                        <vue-form-generator
                            :schema="parsed.schema"
                            :model="parsed.model"
                            :options="parsed.options"
                        ></vue-form-generator>
                    </form>
                    <b-btn
                        variant="primary"
                        @click="submitForm"
                        :click="formsubmission.saving || formsubmission.id"
                        >{{ $t('label.submitForm') }}</b-btn
                    >
                </div>
            </b-card-body>
        </div>
    </b-card>
</template>

<script>
import JqFormToVueForm from '@/helpers/JqFormToVueForm'
import GenericModel from '@/models/GenericModel'

import { has } from 'lodash'

export default {
    props: {
        formId: {
            default: '',
        },
        formData: {
            type: Object,
        },
    },
    components: {},

    data() {
        return {
            formsubmission: new GenericModel(),
            editForm: false,
            parsed: {
                options: {
                    validateAfterChanged: true,
                    validateAfterLoad: true,
                },
            },
        }
    },

    created() {
        this.parseJqForm()
        this.formsubmission.setResourceName('formsubmission')

        this.formsubmission.on('save', () => {
            this.formsubmitted = true
        })
    },

    methods: {
        submitForm() {
            let data = JSON.parse(JSON.stringify(this.parsed.model))

            // Validate form
            if (!this.isFormValid()) {
                this.$refs.form.reportValidity()
                return false
            }

            this.formsubmission.clearState()
            this.formsubmission.set('form_id', this.formData.id)
            this.formsubmission.set('data', data)
            this.formsubmission
                .save()
                .then(this.formSubmitSuccess, this.formSubmitError)
        },

        formSubmitSuccess() {
            this.parseJqForm()
        },

        formSubmitError() {
            // console.log('Error', err)
        },

        parseJqForm() {
            let schema = JSON.parse(this.formData.form_schema)
            let jqformparser = new JqFormToVueForm(schema)

            this.parsed = {
                model: jqformparser.getModel(),
                schema: {
                    groups: jqformparser.getSchema(),
                },
            }
        },

        isFormValid() {
            if (!has(this.$refs, 'form')) {
                return false
            }

            return this.$refs.form.checkValidity()
        },
    },

    computed: {
        formValid() {
            return this.isFormValid
        },

        schema() {
            return JSON.parse(this.formData.form_schema)
        },

        canEditForms() {
            return this.$store.getters['auth/user'].role.rank < 30
                ? true
                : false
        },
    },

    watch: {
        formId() {
            this.parseJqForm()
        },
    },
}
</script>
